import React from 'react';
import Progress from 'redux-progress';
import {
  notPartOfForRenewKeys,
  isSupportOnlyProductKey,
  isFutureEndDate,
  isCommercialOrAcademicOrStarterType,
  isSocialImpactOrOpenSourceLicenseType,
} from 'util/mac/helpers';
import { StyledButtonsWrapper, StyledFlex } from '../StyledComponents';
import { ActionsMessage } from './ActionsMessage';
import { RenewLink } from './RenewLink';
import { UpgradeLink } from './UpgradeLink';
import { ArchiveUnarchiveButtonLink } from './ArchiveUnarchiveButtonLink';
import { ClaimYourSiteLink } from './ClaimYourSiteLink';

type EndUserAccountProps = {
  isRenewableAccount: Progress<boolean>;
  isUpgradableAccount: Progress<boolean>;
  isArchived: boolean;
  isAccount: boolean;
  accountDetails: any;
  productPackage: any;
  isActivePartner?: boolean;
};

export const EndUserAccount = ({
  isRenewableAccount,
  isUpgradableAccount,
  isArchived,
  isAccount,
  accountDetails,
  productPackage,
  isActivePartner,
}: EndUserAccountProps) => {
  const {
    isUnclaimedCloudSite,
    id: accountId,
    externalUuid,
    active: isAccountActive,
    accountPriceOverrideType,
    latestPeriod: { endDate },
    merchandise: {
      details: { licenseType },
    },
  } = accountDetails;
  const { key } = productPackage;

  const isRenewable =
    !notPartOfForRenewKeys.includes(key) && (isSupportOnlyProductKey(key) || isRenewableAccount);

  const isUpgradable =
    isAccountActive &&
    !isSocialImpactOrOpenSourceLicenseType(accountPriceOverrideType) &&
    isUpgradableAccount;

  const renderButtons = () => {
    const buttons = [
      isActivePartner && isUnclaimedCloudSite && isFutureEndDate(endDate) && (
        <ClaimYourSiteLink externalUuid={externalUuid} />
      ),
      isActivePartner && isCommercialOrAcademicOrStarterType(licenseType) && isRenewable && (
        <RenewLink accountId={accountId} />
      ),
      isActivePartner && isCommercialOrAcademicOrStarterType(licenseType) && isUpgradable && (
        <UpgradeLink accountId={accountId} productPackageKey={key} />
      ),
      <ArchiveUnarchiveButtonLink
        key="archive-unarchive-link"
        isArchiveButtonVisible
        isArchived={isArchived}
        accountId={accountId}
        isAccount={isAccount}
      />,
    ];
    return buttons.filter(Boolean);
  };

  return (
    <StyledFlex>
      <ActionsMessage />
      <StyledButtonsWrapper>{renderButtons()}</StyledButtonsWrapper>
    </StyledFlex>
  );
};
